import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'phone',
  standalone: true
})
export class PhonePipe implements PipeTransform {

  transform(value: string, base = '44', ...args: unknown[]): string {
    var regex = new RegExp(`^\\+${base}\\s*`);
    const domestic = value?.replace(regex, '').trim();
    return domestic ? `0${domestic}` : '';
  }
}
